import React from "react";
import { Box, Card, Grid, Stack, Typography, Skeleton } from "@mui/material";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import { PALETTE } from "../types";

type Counts = { pending: number; approved: number; rejected: number; all: number };

const Tile: React.FC<{ label: string; value: React.ReactNode; sublabel?: string; accent: string; bg: string; icon: React.ReactNode }> = ({ label, value, sublabel, accent, bg, icon }) => (
  <Card sx={{ p: 2, borderRadius: 2.5, border: `1px solid ${PALETTE.border}`, height: "100%", boxShadow: "none", position: "relative", overflow: "hidden",
    "&::before": { content: '""', position: "absolute", left: 0, top: 0, bottom: 0, width: 3, bgcolor: accent },
  }}>
    <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mb: 0.5 }}>
      <Box sx={{ width: 30, height: 30, borderRadius: "8px", bgcolor: bg, color: accent, display: "flex", alignItems: "center", justifyContent: "center", "& svg": { fontSize: 18 } }}>{icon}</Box>
      <Typography sx={{ fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.05em", color: PALETTE.slate }}>{label}</Typography>
    </Stack>
    <Typography sx={{ fontSize: 24, fontWeight: 800, color: PALETTE.ink, lineHeight: 1.15 }}>{value}</Typography>
    {sublabel && <Typography sx={{ fontSize: 11.5, color: "text.secondary", mt: 0.25 }}>{sublabel}</Typography>}
  </Card>
);

const MasteryApprovalSummary: React.FC<{ counts?: Counts; loading?: boolean }> = ({ counts, loading }) => {
  const values = counts ?? { pending: 0, approved: 0, rejected: 0, all: 0 };
  return (
    <Grid container spacing={2}>
      <Grid item xs={6} md={3}>
        {loading ? <Skeleton variant="rounded" height={92} />
          : <Tile label="Pending Review" value={values.pending} sublabel="awaiting supervisor" accent={PALETTE.pending.accent} bg={PALETTE.pending.bg} icon={<PendingActionsIcon />} />}
      </Grid>
      <Grid item xs={6} md={3}>
        {loading ? <Skeleton variant="rounded" height={92} />
          : <Tile label="Approved" value={values.approved} sublabel="all-time decisions" accent={PALETTE.approved.accent} bg={PALETTE.approved.bg} icon={<CheckCircleOutlineIcon />} />}
      </Grid>
      <Grid item xs={6} md={3}>
        {loading ? <Skeleton variant="rounded" height={92} />
          : <Tile label="Rejected" value={values.rejected} sublabel="all-time decisions" accent={PALETTE.rejected.accent} bg={PALETTE.rejected.bg} icon={<CancelOutlinedIcon />} />}
      </Grid>
      <Grid item xs={6} md={3}>
        {loading ? <Skeleton variant="rounded" height={92} />
          : <Tile label="Total Reviews" value={values.all} sublabel="in current scope" accent={PALETTE.navy} bg={PALETTE.info.bg} icon={<BarChartOutlinedIcon />} />}
      </Grid>
    </Grid>
  );
};

export default MasteryApprovalSummary;
